export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200/50 p-8 md:p-10">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="flex-1 text-center md:text-left">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
                  随时随地，吃瓜不耽误
                </h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  51吃瓜黑料全面适配移动端，打开手机浏览器即可流畅观看所有51吃瓜视频和黑料爆料视频。安卓、苹果全平台兼容，无需下载APP，随时随地掌握最新吃瓜动态。
                </p>
                <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
                  <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 text-sm text-foreground-700 font-medium">
                    <i className="ri-android-line text-lg text-accent-500"></i>
                    Android 浏览器
                  </span>
                  <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 text-sm text-foreground-700 font-medium">
                    <i className="ri-apple-line text-lg text-foreground-700"></i>
                    iOS Safari
                  </span>
                  <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 text-sm text-foreground-700 font-medium">
                    <i className="ri-computer-line text-lg text-primary-500"></i>
                    PC 浏览器
                  </span>
                </div>
              </div>
              <div className="flex-shrink-0 w-40 md:w-48">
                <div className="aspect-[3/4] rounded-2xl bg-background-100 border border-background-200/50 overflow-hidden">
                  <div className="h-full flex flex-col items-center justify-center p-4 text-center">
                    <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-3">
                      <i className="ri-smartphone-line text-2xl text-primary-500"></i>
                    </div>
                    <span className="text-xs font-bold text-foreground-900">51吃瓜黑料</span>
                    <span className="text-xs text-foreground-500 mt-1">移动网页版</span>
                    <div className="mt-3 px-3 py-1.5 rounded-full bg-primary-500 text-background-50 text-xs font-bold">
                      立即访问
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}